import type { RouteObject } from "react-router-dom";
import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { ProtectedRoute } from "../auth/components/ProtectedRoute";

const AccountLayout = lazy(() => import("./pages/AccountLayout").then(m => ({ default: m.AccountLayout })));
const AccountProfilePage = lazy(() => import("./pages/AccountProfilePage").then(m => ({ default: m.AccountProfilePage })));
const AccountNotificationsPage = lazy(() => import("../notifications/pages/AccountNotificationsPage").then(m => ({ default: m.AccountNotificationsPage })));
const AccountHub = lazy(() => import("./pages/AccountHub").then(m => ({ default: m.AccountHub })));

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex h-[50vh] w-full items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>}>
    {children}
  </Suspense>
);
import { shippingRoutes } from "../shipping/shipping.routes";
import { ordersRoutes } from "../orders/orders.routes";
import { reviewsRoutes } from "../reviews/reviews.routes";
import { wishlistRoutes } from "../wishlist/wishlist.routes";



export const accountRoutes: RouteObject[] = [
    {
        path: "account",
        element: (
            <ProtectedRoute>
                <AccountLayout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: (
                  <SuspenseWrapper>
                    <AccountHub />
                  </SuspenseWrapper>
                ),
            },
            {
                path: "profile",
                element: (
                  <SuspenseWrapper>
                    <AccountProfilePage />
                  </SuspenseWrapper>
                ),
            },
            {
                path: "orders",
                children: ordersRoutes,
            },
            {
                path: "notifications",
                element: (
                  <SuspenseWrapper>
                    <AccountNotificationsPage />
                  </SuspenseWrapper>
                ),
            },
            {
                path: "pending-reviews",
                children: reviewsRoutes,
            },
            {
                path: "reviews",
                children: reviewsRoutes,
            },
            {
                path: "addresses",
                children: shippingRoutes,
            },
            {
                path: "wishlist",
                children: wishlistRoutes,
            },

        ],
    },
];
